import type { FaireProductEntity } from "../../entity_types/product";

export const p_5e83k494kt: FaireProductEntity = {
  token: "p_5e83k494kt",
  type: "product",
  name: "* KIDS * The Lake Days Club Boxy Cotton Kids T-Shirt",
  brandToken: "b_jbqutfkjxx",
  brandName: "The Clandestine Underground",
  imageUrl:
    "https://cdn.faire.com/fastly/b5f7267315a3d95d795dea52c1d1b8f3b3abc8e598e86917b97f5fbc7c7dbfaf.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ea5dec9e7ad0d91a8858c1a29f5b975c195b4c8ef1552d0b21a4aa931f80d0a2.jpeg",
    "https://cdn.faire.com/fastly/e266b4f7d7ddbfae69a47c682d8940bc9f999418affe9e41e863169e99798d2f.jpeg",
    "https://cdn.faire.com/fastly/4dea3001d4d0f8f27f993a1ece44dc4cb1340c88aadde659e679b248ebfdeaf6.jpeg",
    "https://cdn.faire.com/fastly/ceff5cd1d3ca2f3f99fcdede10a51af8350c2ad11489830c87749992bf4c0520.jpeg",
    "https://cdn.faire.com/fastly/2dbf0d1c20bb56cd32412c2a78d5e6afa0d9fafacd9b52c950c478425f0f38f6.jpeg",
    "https://cdn.faire.com/fastly/52e8a84593891ce6131ed3c239c58e050ebeb24c122297886a7be2cd086511d8.jpeg",
    "https://cdn.faire.com/fastly/2e3a97aed00d8bb741d13d8f3701061050550844241e1d5b50a2fcc970811d28.jpeg",
    "https://cdn.faire.com/fastly/894b1ad8f6074c56508d1dd27b95d063090f04295331fa158b5bd1c21e5f296d.jpeg",
    "https://cdn.faire.com/fastly/4af7fd06fd0aaef0f703fb39b2184ca3f3c27021371dd7d5bc237435bd143c98.png",
    "https://cdn.faire.com/fastly/cd3c2826d7789f15b7b60234cb69ff8ce7a91377a4d904c09ff7c694f68f7a3b.png",
    "https://cdn.faire.com/fastly/092c3046a1c79c4c9ee70f88b6405fa8dcf06568530cece679aecb2c18309f75.png",
  ],
  priceDollars: 20.79,
  description:
    '* MADE IN USA. 6.5 OZ. 100% COTTON. *\n\nGet all of the Summer vibes in our vintage Lake Days inspired boxy cotton kids t-shirt.\n\n- Features "The Lake Days Club" with "Locals Only - The Lake Days Club. Established 1993" to the side/bottom of a girl by the lake in pink and green ink\n\n- Screen print transfer that is heat pressed onto each tshirt\n\n- Tshirt is a super soft vintage wash that gets softer after each wash, features drop shoulder and a double stitch collar\n\n- Meant to be a Boxy fit\n\n- Refer to photos for size references on how the tees fit -- Model in Blue Jean is typically a size 2T wearing a size 4/5 | Model in Ivory  is typically a size 10 wearing a size 12\n\n- 100% Cotton\n\n* due to screens and filters colors may vary slightly to photos - colors on mock up most closely represent the color of the actual item as our product photos have filters on them that can affect the colors / lighting *',
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:36.744Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
